import { Text, Space } from "@mantine/core";

function EventDetails(props) {

    return (
        <div>
            
            <Space h="md"></Space>
            <Text align="left">
                <strong>Date:</strong> Sunday, May 18, 2025
            </Text>
            <Text align="left">
                <strong>Time:</strong> 11:00 AM (Walk starts at 11:30 AM followed by lunch)
            </Text>
            <Text align="left">
                <strong>Where:</strong> Centennial Park - Picnic Area 6 & 7
            </Text>
            <Text align="left">
                <strong>Address/Parking:</strong> 150 Elmcrest Rd, Etobicoke, ON M9C 3S2
            </Text>
            <Text align="left">
                <strong>Cost:</strong> $10 minimum per person with all ticket sales going to the World Partnership Walk
            </Text>
            <Space h="md"></Space>
            <Text align="left">
                <strong>Space at the picnic area is limited.  Tickets were available on a first come first serve basis and are now SOLD OUT.  Additional tickets WILL NOT be sold on the day of the event.</strong>
            </Text>
        </div>
    )
}
export default EventDetails;